import React from 'react';

// Russian translations
export const russianTranslations = {
  // ========== NAVIGATION & LAYOUT ==========
  title: "Duelity Gaming Tournament Platform",
  welcome: "Добро пожаловать",
  points: "Очки",
  logout: "Выход",
  tournaments: "Турниры",
  pointsProfile: "Очки и профиль",
  matchHistory: "История матчей",
  adminPanel: "Панель администратора",
  approverPanel: "Панель одобрителя",
  supervisorPanel: "Панель супервайзера",
  managerPanel: "Панель менеджера",
  login: "Вход",
  register: "Регистрация",
  myProfile: "Мой профиль",
  dontHaveAccount: "Нет аккаунта?",
  language: "Язык",
  liveChat: "Чат",
  menu: "Меню",
  publicProfile: "ПУБЛИЧНЫЙ",
  levelsBadges: "Уровень и значки",

  // ========== AUTHENTICATION ==========
  username: "Имя пользователя",
  password: "Пароль",
  email: "Электронная почта",
  inGameName: "Игровое имя",
  backToLogin: "Вернуться к входу",
  createAccount: "Создать аккаунт",
  loginSuccessful: "Вход выполнен успешно!",
  welcomeBattlefield: "Добро пожаловать на поле боя!",
  registrationSuccessful: "Регистрация успешна!",
  logoutSuccessful: "Выход выполнен успешно",
  loggingIn: "Вход...",
  creatingAccount: "Создание аккаунта...",

  // ========== ПРОВЕРКА ПОЛЕЙ ==========
  loginSubtitle: "Войдите в свой аккаунт",
  fillAllFields: "Заполните все поля для создания аккаунта",
  enterUsername: "Введите имя пользователя",
  enterPassword: "Введите пароль",
  enterEmail: "Введите электронную почту",
  enterInGameName: "Enter your in-game name",
  reenterPassword: "Повторите пароль",
  confirmPassword: "Подтвердите пароль",

  // Ошибки проверки
  usernameRequired: "Имя пользователя обязательно",
  usernameTooShort: "Имя пользователя должно содержать минимум 3 символа",
  usernameTooLong: "Имя пользователя должно быть меньше 20 символов",
  usernameNoHebrew: "Имя пользователя не может содержать символы иврита",
  usernameNoArabic: "Имя пользователя не может содержать арабские символы",
  usernameInvalidChars: "Имя пользователя может содержать только буквы, цифры, подчёркивание и дефис",
  emailRequired: "Электронная почта обязательна",
  emailInvalid: "Пожалуйста, введите корректный адрес электронной почты",
  inGameNameRequired: "Игровое имя обязательно",
  inGameNameTooShort: "Игровое имя должно содержать минимум 2 символа",
  inGameNameTooLong: "Игровое имя должно быть меньше 30 символов",
  passwordRequired: "Пароль обязателен",
  passwordTooShort: "Пароль должен содержать минимум 6 символов",
  passwordTooLong: "Пароль должен быть меньше 50 символов",
  passwordNeedsNumber: "Пароль должен содержать хотя бы одну цифру",
  passwordNeedsLetter: "Пароль должен содержать хотя бы одну букву",
  confirmPasswordRequired: "Пожалуйста, подтвердите пароль",
  passwordsDoNotMatch: "Пароли не совпадают",

  // Успешная проверка
  usernameValid: "Имя пользователя корректно",
  emailValid: "Электронная почта корректна",
  inGameNameValid: "Игровое имя корректно",
  passwordValid: "Пароль корректен",
  passwordsMatch: "Пароли совпадают",

  // Требования к паролю
  min6Chars: "Минимум 6 символов",
  hasLetter: "Содержит букву",
  hasNumber: "Содержит цифру",

  // Ошибки входа
  invalidCredentials: "Неверное имя пользователя или пароль",
  userNotFound: "Пользователь не найден. Проверьте имя пользователя.",
  wrongPassword: "Неверный пароль. Попробуйте ещё раз.",
  accountDisabled: "Ваш аккаунт отключён. Обратитесь в поддержку.",
  loginFailed: "Ошибка входа. Попробуйте ещё раз.",
  registrationFailed: "Ошибка регистрации. Попробуйте ещё раз.",


  // ========== PASSWORD RECOVERY ==========
  forgotPassword: "Забыли пароль?",
  forgotPasswordTitle: "Забыли пароль",
  forgotPasswordSubtitle: "Введите адрес электронной почты, и мы отправим вам ссылку для сброса пароля.",
  sendResetLink: "Отправить ссылку",
  sending: "Отправка...",
  checkYourEmail: "Проверьте свою почту",
  resetLinkSent: "Если учетная запись с этим адресом существует, вы скоро получите ссылку для сброса. Пожалуйста, проверьте также папку спам.",
  linkExpiresIn: "Ссылка истечет через 1 час.",
  resetPassword: "Сбросить",
  resetPasswordTitle: "Сброс пароля",
  resetPasswordSubtitle: "Введите новый пароль ниже.",
  newPassword: "Новый пароль",
  confirmNewPassword: "Подтвердите пароль",
  enterNewPassword: "Введите новый пароль",
  confirmNewPasswordPlaceholder: "Подтвердите новый пароль",
  resetting: "Сброс...",
  passwordResetSuccess: "Пароль сброшен!",
  passwordResetSuccessMessage: "Ваш пароль был успешно сброшен.",
  redirectingToLogin: "Перенаправление на страницу входа...",
  loginNow: "Войти",
  invalidResetLink: "Недействительная ссылка",
  invalidResetLinkMessage: "Эта ссылка недействительна или истекла.",
  resetLinkExpiredNote: "Ссылки истекают через 1 час в целях безопасности.",
  requestNewResetLink: "Запросить новую ссылку",
  verifyingResetLink: "Проверка ссылки...",

// ========== ВОССТАНОВЛЕНИЕ ПАРОЛЯ ==========  forgotPassword: "Забыли пароль?",  forgotPasswordTitle: "Забыли пароль",  forgotPasswordSubtitle: "Введите адрес электронной почты, и мы отправим вам ссылку для сброса пароля.",  sendResetLink: "Отправить ссылку",  sending: "Отправка...",  checkYourEmail: "Проверьте свою почту",  resetLinkSent: "Если учетная запись с этим адресом существует, вы скоро получите ссылку для сброса. Пожалуйста, проверьте также папку спам.",  linkExpiresIn: "Ссылка истечет через 1 час.",  resetPassword: "Сбросить",  resetPasswordTitle: "Сброс пароля",  resetPasswordSubtitle: "Введите новый пароль ниже.",  newPassword: "Новый пароль",  confirmNewPassword: "Подтвердите пароль",  enterNewPassword: "Введите новый пароль",  confirmNewPasswordPlaceholder: "Подтвердите новый пароль",  resetting: "Сброс...",  passwordResetSuccess: "Пароль сброшен!",  passwordResetSuccessMessage: "Ваш пароль был успешно сброшен.",  redirectingToLogin: "Перенаправление на страницу входа...",  loginNow: "Войти",  invalidResetLink: "Недействительная ссылка",  invalidResetLinkMessage: "Эта ссылка недействительна или истекла.",  resetLinkExpiredNote: "Ссылки истекают через 1 час в целях безопасности.",  requestNewResetLink: "Запросить новую ссылку",  verifyingResetLink: "Проверка ссылки...",
  // ========== LEVEL SYSTEM CORE ==========
  level: "Уровень",
  levels: "Уровни",
  experience: "Опыт",
  exp: "Опыт",
  totalExp: "Всего опыта",
  expNeeded: "Требуется опыта",
  expToNext: "Опыта до следующего уровня",
  expGained: "Получено опыта",
  expReward: "Награда опытом",
  currentLevel: "Текущий уровень",
  nextLevel: "Следующий уровень",
  maxLevel: "МАКСИМАЛЬНЫЙ УРОВЕНЬ!",
  levelUp: "ПОВЫШЕНИЕ УРОВНЯ!",
  levelProgress: "Прогресс уровня",
  levelSystem: "Система уровней",
  loadingLevel: "Загрузка уровня...",
  levelTooltip: "Уровень {level} - {title}\n{totalExp} всего опыта\n{remaining}",

  // ========== LEVEL TITLES ==========
  beginner: "Новичок",
  novice: "Начинающий",
  intermediate: "Средний",
  advanced: "Продвинутый",
  professional: "Профессионал",
  expert: "Эксперт",
  master: "Мастер",
  grandmaster: "Гроссмейстер",
  mythic: "Мифический",
  sage: "Мудрец",
  legend: "Легенда",

  // ========== BADGES SYSTEM ==========
  badges: "Значки",
  badge: "Значок",
  earnedBadges: "Получено",
  inProgress: "В процессе",
  allBadges: "Все",
  loadingBadges: "Загрузка значков...",
  noBadges: "Пока нет значков",
  badgeUnlocked: "Значок разблокирован!",
  badgeProgress: "Прогресс значка",
  badgeModal: "Детали значка",
  comingSoon: "Скоро",
  systemLoading: "Загрузка системы...",
  noBadgesYet: "Пока нет значков",
  characterCount: "{count}/1000",
  progressPercentage: "{percentage}% завершено",
  currentProgress: "Текущий прогресс",

  // ========== BADGE CATEGORIES ==========
  allCategories: "Все категории",
  winStreak: "Серия побед",
  filler: "Наполнитель",
  totalWins: "Всего побед",
  pointsWinning: "Выигрыш очков",
  pointsPurchase: "Покупка очков",
  multiplayer: "Мультиплеер",
  battleRoyale: "Королевская битва",
  multiplayerWins: "Победы в мультиплеере",
  battleRoyaleWins: "Победы в королевской битве",

  // ========== BADGE RARITIES ==========
  common: "Обычный",
  rare: "Редкий",
  epic: "Эпический",
  legendary: "Легендарный",

  // ========== BADGE MODAL ==========
  close: "Закрыть",
  category: "Категория",
  requirement: "Требование",
  unlocked: "Разблокировано",
  unlockedOn: "Разблокировано",
  progress: "Прогресс",
  remaining: "осталось",
  tip: "Совет",
  gotIt: "Понял!",

  // ========== PROGRESS INDICATORS ==========
  complete: "Завершено",
  completion: "Завершение",
  showMore: "Показать больше",
  showLess: "Показать меньше",
  upcoming: "Предстоящие",
  upcomingMilestones: "Предстоящие вехи",
  congratsMaxLevel: "Поздравляем! Вы достигли максимального уровня!",
  totalExpEarned: "Всего заработано опыта",
  progressDetails: "Детали прогресса",
  expForCurrentLevel: "Опыт текущего уровня",
  expForNextLevel: "Опыт для следующего уровня",
  progressToNext: "Прогресс к следующему уровню",

  // ========== STATUS INDICATORS ==========
  loading: "Загрузка...",
  loadingProgress: "Загрузка прогресса...",
  offline: "Оффлайн",
  online: "Онлайн",

  // ========== BADGE TIPS ==========
  winStreakTip: "Продолжайте выигрывать подряд, чтобы достичь этой цели! Вам нужно еще {remaining} побед подряд.",
  totalWinsTip: "Выигрывайте больше турниров, чтобы получить этот значок. Осталось {remaining} побед!",
  pointsWinningTip: "Зарабатывайте больше очков, выигрывая турниры. Вам нужно еще {remaining} очков.",
  pointsPurchaseTip: "Купите больше очков, чтобы получить этот значок. Осталось купить {remaining} очков.",
  fillerTip: "Добавляйте наполнителей в турниры и надейтесь на их победу! Нужно еще {remaining} побед наполнителей.",
  multiplayerTip: "Играйте больше мультиплеерных турниров. Осталось {remaining} игр.",
  battleRoyaleTip: "Участвуйте в большем количестве матчей Королевской битвы. Осталось {remaining} игр.",
  multiplayerWinsTip: "Выигрывайте больше мультиплеерных турниров. Нужно еще {remaining} побед.",
  battleRoyaleWinsTip: "Выигрывайте больше матчей Королевской битвы. Осталось {remaining} побед.",
  genericTip: "Продолжайте играть, чтобы получить этот значок! Осталось {remaining}.",

  // ========== LEVEL UP NOTIFICATIONS ==========
  levelUpNotification: "Повышение уровня!",
  levelUpTitle: "Поздравляем!",
  levelUpSubtitle: "Вы достигли нового уровня!",
  newLevelUnlocked: "Новый уровень разблокирован",
  titleEarned: "Получен титул",

  // ========== STATISTICS ==========
  statistics: "Статистика",
  totalEarned: "Всего заработано",
  totalAvailable: "Всего доступно",
  completionPercentage: "Процент завершения",
  earnedCount: "Количество полученных",
  progressCount: "Количество в процессе",

  // ========== ACHIEVEMENT MESSAGES ==========
  achievementUnlocked: "Достижение разблокировано!",
  newBadgeEarned: "Получен новый значок!",
  levelMilestone: "Веха уровня!",
  experienceGained: "Получено опыта: +{amount}",

  // ========== ERROR MESSAGES ==========
  failedToLoadBadges: "Не удалось загрузить значки",
  failedToLoadLevel: "Не удалось загрузить уровень",
  failedToLoadProgress: "Не удалось загрузить прогресс",

  // ========== ACTION BUTTONS ==========
  viewDetails: "Подробнее",
  trackProgress: "Отслеживать прогресс",
  shareAchievement: "Поделиться достижением",

  // ========== NOTIFICATIONS ==========
  badgeEarned: "Получен значок: {badgeName}",
  levelIncreased: "Повышение уровня! Теперь уровень {level}",
  milestoneReached: "Веха достигнута!",

  // ========== COMPACT DISPLAYS ==========
  lvl: "Ур",
  expShort: "Опыт",
  badgesShort: "Значки",

  // ========== PROGRESS BARS ==========
  progressBarLabel: "Прогресс: {current}/{total}",
  completionRate: "Процент завершения: {percentage}%",

  // ========== TIME-BASED ==========
  recentlyUnlocked: "Недавно разблокировано",
  timeToUnlock: "Время до разблокировки",
  earnedToday: "Заработано сегодня",
  earnedThisWeek: "Заработано на этой неделе",

  // ========== FILTERS AND SORTING ==========
  filterByCategory: "Фильтр по категории",
  sortByProgress: "Сортировка по прогрессу",
  sortByRarity: "Сортировка по редкости",
  sortByDate: "Сортировка по дате",

  // ========== HELP TEXT ==========
  howToEarnBadges: "Как получить значки",
  levelSystemExplanation: "Объяснение системы уровней",
  experienceExplanation: "Объяснение очков опыта",

  // ========== SPECIAL EVENTS ==========
  specialEvent: "Специальное событие",
  limitedTime: "Ограниченное время",
  eventBadge: "Значок события",
  seasonalBadge: "Сезонный значок",

  // ========== PUBLIC PROFILE TRANSLATIONS ==========
  profileTitle: "Профиль {name}",
  playerNotFound: "Игрок не найден",
  profilePrivate: "Этот профиль приватный",
  failedToLoadProfile: "Не удалось загрузить профиль",
  playerNotFoundDesc: "Игрок, которого вы ищете, не существует или был заблокирован.",
  profilePrivateDesc: "Этот игрок сделал свой профиль приватным.",
  profileLoadError: "Произошла ошибка при загрузке профиля. Пожалуйста, попробуйте снова.",
  yourProfile: "Ваш профиль",
  searchOtherPlayer: "Искать другого игрока",
  findPlayer: "Найти игрока",
  searchPlayerDesc: "Найдите любого игрока по имени пользователя или игровому имени, чтобы просмотреть его публичный профиль.",
  loadingProfile: "Загрузка профиля...",
  loadingPlayerProfile: "Загрузка профиля игрока...",
  playerProfiles: "Профили игроков",

  // ========== LEADERBOARD TRANSLATIONS ==========
  wins: "Победы",
  avgPrize: "Средний приз",
  totalPrize: "Общий приз",
  losses: "Поражения",
  leaderboard: "Таблица лидеров",
  levelLeaderboard: "Таблица лидеров по уровню",
  winsLeaderboard: "Таблица лидеров по победам",
  winStreakLeaderboard: "Таблица лидеров по серии побед",
  pointsLeaderboard: "Таблица лидеров по очкам",
  levelLeaderboardDesc: "Лучшие игроки по очкам опыта и уровню",
  winsLeaderboardDesc: "Лучшие игроки по общему количеству побед в турнирах",
  winStreakLeaderboardDesc: "Лучшие игроки с текущими сериями побед",
  pointsLeaderboardDesc: "Лучшие игроки по текущему балансу очков",
  loadingLeaderboard: "Загрузка таблицы лидеров...",
  loadingRankings: "Загрузка рейтингов игроков...",
  failedToLoadLeaderboard: "Не удалось загрузить таблицу лидеров",
  leaderboardRefreshed: "Таблица лидеров обновлена!",
  leaderboardLoadError: "Произошла ошибка при загрузке таблицы лидеров. Пожалуйста, попробуйте снова.",
  noDataAvailable: "Нет данных",
  noActiveStreaks: "У игроков сейчас нет активных серий побед.",
  noPlayersFound: "Игроки не найдены для этой таблицы лидеров.",
  fullRankings: "Полный рейтинг",
  champion: "Чемпион",
  currentStreak: "Текущая серия",
  maxStreak: "Макс",
  levelDesc: "По опыту",
  winsDesc: "По победам",
  winStreakDesc: "Текущие серии",
  pointsDesc: "По балансу",
  lastUpdated: "Последнее обновление",
  accountAge: "Возраст аккаунта",
  days: "дней",
  you: "(Вы)",
  searchFromLeaderboard: "Поиск игрока...",

  // ========== ENHANCED PROFILE COMPONENTS ==========
  profile: "Профиль",
  overview: "Обзор",
  mainAdmin: "Главный администратор",
  supervisor: "Супервайзер",
  approver: "Одобритель",
  manager: "Менеджер",
  verifiedSponsor: "Верифицированный Спонсор",
  player: "Игрок",
  memberSince: "Участник с ",
  lastSeen: "Последняя активность",
  currentlyOnline: "Сейчас:",
  fillerWins: "Победы наполнителя",
  bestWinStreak: " Лучшая серия побед",
  gameModeStats: "Статистика режимов игры",
  accountInformation: "Информация об аккаунте",
  funStats: "Интересная статистика",
  played: "Сыграно",
  multiplayerWinRate: "Процент побед в мультиплеере",
  battleRoyaleWinRate: "Процент побед в Королевской битве",

  // ========== SEARCH AND GENERAL ==========
  search: "Поиск",
  searchForPlayer: "Поиск игрока",
  searchPlayerPlaceholder: "Поиск по имени пользователя или игровому имени...",
  searching: "Поиск...",
  playersFound: "игроков найдено",
  noPlayersFoundSearch: "Игроки не найдены по запросу \"{query}\"",
  searchTipExact: "Попробуйте искать по точному имени пользователя или игровому имени",
  searchTipUsername: "Поиск по имени пользователя (например, @player123)",
  searchTipInGame: "Поиск по игровому имени (например, ProGamer)",
  searchTip: "Используйте ↑↓ для навигации, Enter для выбора, Esc для закрытия",

  // ========== BADGES AND PROFILE SPECIFIC ==========
  badgeCollection: "Коллекция значков",
  earned: "Получено",
  categoryBreakdown: "Разбивка по категориям",
  achievementSummary: "Сводка достижений",
  badgeSystemNotAvailable: "Система значков недоступна для этого профиля.",
  badgesPrivateDesc: "Этот игрок сделал свою коллекцию значков приватной.",
  badgesLoadError: "Произошла ошибка при загрузке коллекции значков.",
  badgeSummaryText: "получил {earned} из {total} доступных значков ({percentage}% завершения). Он разблокировал {categories} разных категорий и получил всего {exp} очков опыта от значков.",
  recentlyEarned: "Недавно полученные",
  showProgress: "Показать прогресс",
  categoriesUnlocked: "Категории",
  totalExpFromBadges: "Всего опыта от значков",

  // ========== MATCH HISTORY ==========
  noMatches: "Матчи не найдены",
  noMatchesDesc: "Этот игрок еще не завершил ни одного публичного матча.",
  loadingMatches: "Загрузка матчей...",
  total: "Всего",
  prizeWon: "Выиграно призов",
  winRate: "Процент побед",
  map: "Карта",
  maxKills: "Макс. убийств",
  entry: "Вход",
  prize: "Приз",
  players: "Игроки",
  by: "от",
  won: "ПОБЕДА",
  lost: "ПОРАЖЕНИЕ",
  shared: "Разделено",
  thisPlayer: "Этот игрок",
  matchSummary: "Сводка матча",
  winLossRecord: "Соотношение побед/поражений",
  totalPrizeWon: "Всего выиграно призов",
  averagePrize: "Средний приз за победу",

  // ========== DETAILED STATISTICS ==========
  detailedStatistics: "Подробная статистика",
  quickStats: "Быстрая статистика",
  overallPerformance: "Общая производительность",
  gameModeBreakdown: "Разбивка по режимам игры",
  pointsStatistics: "Статистика очков",
  specialAchievements: "Особые достижения",
  playerSummary: "Сводка игрока",
  playerSummaryText: "это {performance} игрок с {wins} победами из {total} матчей, достигший {winRate}% побед. В настоящее время он занимает #{rank} место в глобальном рейтинге.",
  currentStreakText: "У него сейчас серия из {streak} побед подряд!",
  bestStreakText: "Его лучшая серия побед составила {streak} побед подряд.",
  elite: "Элитный",
  pro: "Про",
  average: "Средний",
  fillerMaster: "Мастер наполнителей",
  fillerWinsDesc: "Выиграл турниры с ИИ-наполнителями",
  streakWarrior: "Воин серий",
  streakDesc: "Достиг впечатляющих серий побед",
  globalRank: "Глобальный рейтинг",
  byExperience: "По опыту",
  currentPoints: "Текущие очки",
  pointsWon: "Очки выиграны",
  pointsLost: "Очки потеряны",
  netGain: "Чистый прирост",
  avgPerWin: "Среднее за победу",
  fromLosses: "От поражений",
  pointsPurchased: "Очков куплено",
  teamBased: "Командные матчи",
  survivalMode: "Режим выживания",
  matchesPlayed: "Сыграно матчей",
  totalMatches: "Всего матчей",
  badgesEarned: "Получено значков",
  badgeExp: "Опыт значков",
  categories: "Категории",

  // ========== ROLES ==========
  roleChanged: "Ваша роль была изменена",
  commissionEarned: "Заработано комиссии",
  matchesApproved: "Одобрено матчей",
  approversManaged: "Управляемых одобрителей",
  roleUpdated: "Роль обновлена",
  roleChangedTo: "Ваша роль изменена на",
  changedBy: "Изменено",
  reason: "Причина",
  commissionRates: "Ставки комиссии",

  // ========== TOURNAMENT CLEANUP TRANSLATIONS ==========
  oldTournamentRemoved: 'Старый турнир автоматически удален',
  tournamentsAutoRemoved: '{count} старых турниров удалено из лобби',
  pointsRefunded: '{amount} очков возвращено игрокам',
  adminCleanupActivity: 'Очистка: {deleted} турниров удалено, {refunded} очков возвращено',
  manualCleanupTriggered: 'Ручная очистка от {admin}: {deleted} турниров удалено',
  autoCleanup: 'Авто-очистка',
  removes: 'Удаляет',
  old: 'старые',
  cleanupNow: 'Очистить сейчас',
  active: 'Активно',
  stopped: 'Остановлено',
  onlyMainAdminCanCleanup: 'Только главные администраторы могут запускать ручную очистку',
  manualCleanupCompleted: 'Ручная очистка завершена: {deleted} турниров удалено',
  manualCleanupFailed: 'Ручная очистка не удалась',
  tournamentAutoDeleted: 'Турнир автоматически удален из-за возраста',
  tournamentDeletedOld: 'Старый турнир удален из лобби',
  cleanupServiceActive: 'Сервис очистки активен',
  cleanupServiceStopped: 'Сервис очистки остановлен',
  tournamentCleanupStatus: 'Статус очистки турниров',
  maxAgeInLobby: 'Макс. возраст в лобби',
  cleanupInterval: 'Интервал очистки',
  lastCleanup: 'Последняя очистка',
  nextCleanup: 'Следующая очистка',
  tournamentsProcessed: 'Обработано турниров',
  totalRefundedAmount: 'Всего возвращено',
  cleanupConfiguration: 'Настройка очистки',
  enableAutoCleanup: 'Включить автоматическую очистку',
  maxAgeHours: 'Максимальный возраст (часов)',
  intervalMinutes: 'Интервал очистки (минут)',
  maxPerRun: 'Макс. турниров за раз',
  enableNotifications: 'Включить уведомления',
  saveConfiguration: 'Сохранить настройки',
  configurationSaved: 'Настройки успешно сохранены',
  configurationFailed: 'Не удалось сохранить настройки',
  triggerManualCleanup: 'Запустить ручную очистку',
  cleanupInProgress: 'Очистка в процессе...',
  cleanupCompleted: 'Очистка завершена',
  noOldTournaments: 'Старых турниров не найдено',
  cleanupSummary: 'Сводка очистки',
  deletedCount: 'Удалено',
  refundedAmount: 'Возвращено',
  errors: 'Ошибки',
  duration: 'Продолжительность',
  tournamentAgeWarning: 'Турнир будет автоматически удален через {time}',
  tournamentAgeInfo: 'Возраст турнира: {age}',
  autoDeleteIn: 'Авто-удаление через',
  minutes: 'минут',
  hours: 'часов',

  // ========== FILLER MANAGEMENT ==========
  addFiller: "Добавить наполнителя",
  fillerManagement: "УПРАВЛЕНИЕ НАПОЛНИТЕЛЯМИ",
  fillerPlayers: "Наполнители",
  fillerName: "Имя наполнителя",
  enterFillerName: "Введите имя наполнителя...",
  fillerNameRequired: "Имя наполнителя обязательно",
  fillerNameTooLong: "Имя наполнителя слишком длинное (макс. 20 символов)",
  fillerNameHelp: "Выберите уникальное имя для этого ИИ-игрока (макс. 20 символов)",
  insufficientPointsForFiller: "Недостаточно очков для добавления наполнителя",
  fillerAddedSuccessfully: "Наполнитель \"{name}\" успешно добавлен!",
  failedToAddFiller: "Не удалось добавить наполнителя",
  removeFiller: "Удалить наполнителя",
  fillerRemoved: "Наполнитель успешно удален!",
  fillerRemovedWithRefund: "Наполнитель удален! {amount} очков возвращено.",
  failedToRemoveFiller: "Не удалось удалить наполнителя",
  yourFiller: "(Ваш наполнитель)",
  needMorePoints: "Нужно еще {amount} очков",
  needMoreRealPlayers: "Нужно еще {count} реальных игроков перед добавлением наполнителей, когда турнир заполнится",
  needRealPlayersWarning: "Нужно еще {count} реальных игроков для добавления наполнителей, когда турнир заполнится",
  free: "БЕСПЛАТНО",
  cost: "Стоимость",
  slots: "Слоты",
  slotRemaining: "слот осталось",
  slotsRemaining: "слотов осталось",
  giveawayFillerFree: "Это раздача - наполнители БЕСПЛАТНЫ!",
  fillerCostWarning: "Вы заплатите {cost} очков за этого наполнителя. Если наполнитель выиграет, вы получите приз!",
  fillerAddedAndTournamentUpdated: "Наполнитель добавлен! Турнир обновлен.",

  // ========== COPY FUNCTIONALITY ==========
  noMatchIdToCopy: "Нет ID матча для копирования",
  matchIdCopied: "ID матча скопирован в буфер обмена!",
  noTournamentIdToCopy: "Нет ID турнира для копирования",
  tournamentIdCopied: "ID турнира скопирован в буфер обмена!",

  // ========== SEARCH AND PAGINATION ==========
  searchFinishedTournaments: "Поиск по ID турнира, создателю, режиму или карте...",
  searchResults: "Найдено {count} турниров",
  noSearchResults: "НИЧЕГО НЕ НАЙДЕНО",
  tryDifferentSearch: "Попробуйте другой запрос или очистите поиск",
  previousPage: "Предыдущая страница",
  nextPage: "Следующая страница",
  prev: "Назад",
  next: "Далее",
  pageInfo: "Страница {current} из {total} ({totalItems} всего)",

  // ========== ADMIN PANEL ==========
  mainAdminPanel: "Панель главного администратора",
  commissionSummary: "Сводка комиссии",
  yourCommissionEarned: "Ваша заработанная комиссия",
  asSupervisor: "(как супервайзер)",
  asApprover: "(как одобритель)",
  totalFromUsers: "Всего от пользователей",
  totalToApprovers: "Всего одобрителям",
  totalToSystem: "Всего системе",

  // ========== ADMIN TABS ==========
  stats: "Статистика",
  roles: "Роли",
  pointsTab: "Очки",
  rates: "Ставки",
  users: "Пользователи",
  approvers: "Одобрители",
  inbox: "Входящие",
  pending: "Ожидающие",
  withdrawals: "Выводы",
  transactionLog: "Транзакции",

  // ========== TRANSACTION LOG ==========
  totalTransactions: "Всего транзакций",
  pointsIn: "Очков получено",
  pointsOut: "Очков потрачено",
  filters: "Фильтры",
  hideFilters: "Скрыть",
  showFilters: "Показать",
  transactionType: "Тип",
  searchPlaceholder: "Имя пользователя или описание...",
  startDate: "Начальная дата",
  endDate: "Конечная дата",
  apply: "Применить",
  reset: "Сбросить",
  noTransactions: "Транзакции не найдены",
  transactionsWillAppear: "Транзакции очков от турниров, покупок и действий администратора появятся здесь.",

  // ========== ROLE MANAGEMENT ==========
  userRoleManagement: "Управление ролями пользователей",
  joinDate: 'Дата регистрации',
  totalActiveTime: 'Всего активности',
  avgDailyTime: 'Средн. в день',
  searchUsersModifyRoles: "Найдите пользователей и измените их роли в системе. Только главные администраторы могут изменять роли пользователей.",
  searchUsers: "Поиск пользователей",
  searchByUsername: "Поиск по имени пользователя, email или игровому имени...",
  searchResultsLabel: "Результаты поиска",
  selectedUser: "Выбранный пользователь",
  currentRole: "Текущая роль",
  newRole: "Новая роль",
  roleChangePreview: "Изменение роли:",
  roleChangeDescription: "Изменить роль пользователя",
  reasonForChange: "Причина изменения (необязательно)",
  enterReasonForRoleChange: "Введите причину изменения роли...",
  changeUserRole: "Изменить роль пользователя",
  searchAndSelectUser: "Найдите и выберите пользователя для управления его ролью",
  rolePermissionsGuide: "Руководство по правам ролей",
  fullSystemAccess: "Полный доступ к системе, может управлять всеми пользователями и настройками",
  canManageApprovers: "Может управлять одобрителями и одобрять турниры",
  canApproveTournaments: "Может одобрять турниры и получать комиссию",
  managerAccess: "Доступ супервайзера плюс блокировка пользователей и управление ролями",
  verifiedSponsorAccess: "Может создавать раздачи и турниры на выбывание",
  regularUser: "Обычный пользователь, может участвовать в турнирах",
  cannotBeChanged: "⚠️ Нельзя изменить",

  // ========== POINTS MANAGEMENT ==========
  pointsManagement: "Управление очками",
  searchUsersManagePoints: "Найдите пользователей и управляйте их очками. Вы можете добавлять, удалять или устанавливать определенное количество очков.",
  actionType: "Тип действия",
  add: "Добавить",
  remove: "Удалить",
  set: "Установить",
  pointsAmount: "Количество очков",
  enterPointsAmount: "Введите количество очков...",
  reasonOptional: "Причина (необязательно)",
  enterReasonForPointsAdjustment: "Введите причину корректировки очков...",
  actionAdd: "Добавить",
  actionRemove: "Удалить",
  actionSet: "Установить",
  pointsToUser: "очков для",
  pointsFromUser: "очков от",
  pointsForUser: "очков для",
  newBalance: "Новый баланс:",
  addPoints: "Добавить очки",
  removePoints: "Удалить очки",
  setPoints: "Установить очки",
  searchAndSelectUserPoints: "Найдите и выберите пользователя для управления его очками",

  // ========== COMMISSION SETTINGS ==========
  commissionRateSettings: "Настройки ставок комиссии",
  multiplayerTournaments: "🎯 Мультиплеерные турниры",
  battleRoyaleTournaments: "👑 Турниры Королевской битвы",
  approverCommission: "Комиссия одобрителя (%)",
  systemCommission: "Комиссия системы (%)",
  updateCommissionRates: "Обновить ставки комиссии",
  updating: "Обновление...",

  // ========== USER MANAGEMENT ==========
  allUsers: "Все пользователи",
  ban: "Заблокировать",
  unban: "Разблокировать",

  // ========== APPROVERS MANAGEMENT ==========
  addNewApprover: "Добавить нового одобрителя",
  multiplayerCommissionRange: "Комиссия за мультиплеер (0-{max}%):",
  battleRoyaleCommissionRange: "Комиссия за Королевскую битву (0-{max}%):",
  addAsApprover: "Добавить как одобрителя",
  adding: "Добавление...",
  myApprovers: "Мои одобрители",
  noApproversAdded: "Одобрители еще не добавлены.",

  // ========== TOURNAMENT MANAGEMENT ==========
  matchesReadyForApproval: "Матчи, готовые к одобрению",
  youCanOnlySeeMatches: "ℹ️ Вы видите только матчи, которые не были заняты другими {role} или матчи, которые вы начали одобрять ранее.",
  supervisors: "супервайзерами",
  approversLower: "одобрителями",
  noMatchesReady: "Нет матчей, готовых к одобрению.",
  othersMayHaveClaimed: "Другие {role} могли занять доступные матчи.",
  enterMatchIdFromCod: "Введите ID матча из CoD Mobile",
  approve: "Одобрить",
  approving: "Одобрение...",
  startedBy: "⚠️ Начато:",
  assignedToBot: 'Назначено боту',

  // ========== ACTIVE MATCHES ==========
  activeMatches: "Активные матчи",
  youCanOnlyManageMatches: "ℹ️ Вы видите и можете управлять только матчами, которые вы лично одобрили.",
  noActiveMatches: "Нет активных матчей.",
  haventApprovedMatches: "Вы еще не одобрили ни одного матча или они были завершены.",
  roomLabel: "🎮 ID комнаты",
  generating: "Генерация...",
  noAccess: "🔒 НЕТ ДОСТУПА",
  notInTournament: "Не в этом турнире",
  copyId: "КОПИРОВАТЬ ID",
  joinRoom: "ВОЙТИ",
  roomUrl: "URL комнаты",
  enterRoomUrl: "https://... (опциональная ссылка для входа в комнату)",
  roomUrlDescription: "Если указано, игроки увидят кнопку 'Войти'",
  edit: "РЕДАКТИРОВАТЬ",
  cancel: "ОТМЕНА",
  standby: "⏱️ ОЖИДАНИЕ",
  activeBadge: "🔥 АКТИВНО",
  joined: "✓ ПРИСОЕДИНИЛСЯ",
  selectWinners: "Выбрать победителя",
  selectWinnersPlural: "Выбрать победителей",
  readyForSelection: "⚡ Готово к выбору",
  completeMatch: "Завершить матч",
  completing: "Завершение...",
  winner: "победитель",
  winners: "победителей",
  teamModeInfo: "ℹ️ {mode}: Выберите {count} победителей из команды-победителя",
  duos: "Дуо",
  squads: "Отряды",
  teamMode: "Команда",
  winnerSelectionAvailable: "⚡ Выбор победителя доступен сейчас. Обратный отсчет - это просто крайний срок для присоединения игроков.",

  // ========== EDIT MATCH ID ==========
  editMatchId: "Редактировать ID матча",
  currentMatchId: "Текущий ID матча:",
  newMatchId: "Новый ID матча",
  enterNewMatchId: "Введите новый ID матча из CoD Mobile",
  matchIdCannotBeEmpty: "ID матча не может быть пустым",
  matchIdTooLong: "ID матча должен быть менее 50 символов",
  sameAsCurrentMatchId: "Новый ID матча совпадает с текущим",
  validNewMatchId: "✓ Действительный новый ID матча",
  matchIdHistory: "История ID матча:",
  current: "(текущий)",
  changingMatchIdNotification: "⚠️ Изменение ID матча уведомит всех участников турнира. Убедитесь, что новый ID матча правильный.",
  updateMatchId: "Обновить ID матча",
  updateMatching: "Обновление...",

  // ========== CANCEL TOURNAMENT ==========
  cancelTournament: "Отменить турнир",
  cancellationReason: "Причина отмены",
  enterReasonForCancelling: "Введите причину отмены этого турнира...",
  refundInformation: "⚠️ Информация о возврате:",
  creatorWillReceive: "Создатель получит",
  pointsBack: "очков обратно",
  eachParticipantWillReceive: "Каждый участник получит свой",
  entryFeeBack: "вступительный взнос обратно",
  totalRefund: "Общий возврат",
  giveawayIndicator: "🎁 Турнир-раздача",
  thisActionCannotBeUndone: "⚠️ Это действие нельзя отменить. Всем участникам будет возвращен взнос, и турнир будет навсегда отменен.",
  confirmCancellation: "Подтвердить отмену",
  cancelling: "Отмена...",
  keepTournament: "Сохранить турнир",

  // ========== WITHDRAWAL REQUESTS ==========
  withdrawalRequests: "Запросы на вывод",
  noPendingRequests: "Нет ожидающих запросов.",
  pointsToAmount: "{points} очков → ${amount}",

  // ========== CONFIRMATION MODALS ==========
  confirmRoleChange: "Подтвердить изменение роли",
  roleChangeFromTo: "{currentRole} → {newRole}",
  thisActionWillImmediately: "⚠️ Это действие немедленно изменит роль и права пользователя. Пользователь будет уведомлен об этом изменении.",
  confirmChange: "Подтвердить изменение",
  changingRole: "Изменение роли...",

  // ========== POINTS CONFIRMATION ==========
  confirmPointsAction: "Подтвердить {action} очков",
  pointsAction: "Действие:",
  actionDescription: "{action} {amount} очков {preposition} {username}",
  prepositionTo: "для",
  prepositionFrom: "от",
  prepositionFor: "для",
  thisActionWillUpdatePoints: "⚠️ Это действие немедленно обновит баланс очков пользователя. Убедитесь, что сумма правильная.",
  confirmAction: "Подтвердить {action}",
  processing: "Обработка...",

  // ========== GENERAL CONFIRMATION ==========
  changeUserRoleQuestion: "Изменить роль?",
  banUserQuestion: "Заблокировать пользователя?",
  unbanUserQuestion: "Разблокировать пользователя?",
  removeApproverQuestion: "Удалить одобрителя?",

  // ========== NOTIFICATIONS & MESSAGES ==========
  roleChangedSuccessfully: "Успешно изменена роль {username} на {role}",
  pointsAddedSuccessfully: "Успешно добавлено {points} очков для {username}",
  pointsRemovedSuccessfully: "Успешно удалено {points} очков от {username}",
  pointsSetSuccessfully: "Успешно установлено {points} очков для {username}",
  matchIdUpdatedSuccessfully: "ID матча успешно обновлен",
  tournamentCancelledSuccessfully: "Турнир успешно отменен. {refundInfo}",
  commissionRatesUpdated: "Ставки комиссии успешно обновлены!",
  userBannedSuccessfully: "{username} успешно заблокирован!",
  userUnbannedSuccessfully: "{username} успешно разблокирован!",
  approverAddedSuccessfully: "Одобритель успешно добавлен!",
  approverRemovedSuccessfully: "{username} успешно удален из роли одобрителя!",
  matchApprovedSuccessfully: "Матч успешно одобрен!",
  matchCompletedSuccessfully: "Матч успешно завершен!",
  withdrawalProcessedSuccessfully: "Запрос на вывод успешно {status}!",

  // ========== ERROR MESSAGES ==========
  failedToLoadAdminData: "Не удалось загрузить данные администратора",
  failedToChangeUserRole: "Не удалось изменить роль пользователя",
  failedToManagePoints: "Не удалось управлять очками",
  failedToUpdateMatchId: "Не удалось обновить ID матча",
  failedToCancelTournament: "Не удалось отменить турнир",
  failedToUpdateCommissionRates: "Не удалось обновить ставки комиссии",
  failedToProcessWithdrawal: "Не удалось обработать вывод",
  failedToSearchUsers: "Не удалось найти пользователей",
  invalidUserOrRole: "Неверный пользователь или выбор роли",
  userAlreadyHasRole: "У пользователя уже есть эта роль",
  pleaseSelectUser: "Сначала выберите пользователя",
  pleaseEnterValidAmount: "Введите корректное количество очков",
  pleaseEnterMatchId: "Введите ID матча!",
  pleaseSelectWinner: "Выберите хотя бы одного победителя!",
  unknownAction: "Неизвестное действие: {action}",

  // ========== FORM LABELS & PLACEHOLDERS ==========
  searchResultsCount: "Результаты поиска ({count})",

  // ========== STATUS INDICATORS ==========
  banned: "ЗАБЛОКИРОВАН",
  approved: "ОДОБРЕНО",
  rejected: "ОТКЛОНЕНО",

  // ========== TOURNAMENT CREATION ==========
  upTo: 'До',
  createTournament: "Создать турнир",
  tournamentType: "Тип турнира",
  regularTournament: "🏆 Обычный турнир",
  giveawayTournament: "🎁 Турнир-раздача (бесплатный вход)",

  // Опции участия создателя раздачи
  creatorParticipation: "Ваше участие",
  joinAndPlay: "Присоединиться и играть",
  joinAndPlayDesc: "Вы участвуете в матче",
  spectateGame: "Наблюдать за игрой",
  spectateGameDesc: "Смотреть матч как зритель",
  sponsorOnly: "Только спонсор",
  sponsorOnlyDesc: "Только финансируйте приз, другие играют",
  spectateInfo: "Вы будете в игре как ЗРИТЕЛЬ. Вы можете смотреть, но не играть. Все места открыты для других.",
  sponsorInfo: "Вы НЕ будете добавлены в матч. Все места открыты для других игроков.",
  spectator: "ЗРИТЕЛЬ",

  gameMode: "Режим игры",
  multiplayerType: "Тип матча",
  battleRoyaleType: "Тип Королевской битвы",
  teamMatch: "Командный матч",
  customMode: "Особый режим",
  solo: "Соло",
  duo: "Дуо",
  squad: "Отряд",
  team: "Команда",
  entryFee: "Вступительный взнос",
  totalPrizePool: "Общий призовой фонд",
  roomPassword: "Пароль комнаты",
  optional: "Необязательно",
  estimatedPrizePool: "Ожидаемый призовой фонд",
  totalEntryFees: "Общие вступительные взносы",
  commission: "Комиссия",
  yourEntryFee: "Ваш вступительный взнос",
  yourTotalCost: "Ваша общая стоимость",
  entryFeeForPlayers: "Вступительный взнос для игроков",
  insufficientPoints: "Недостаточно очков!",
  createTournamentBtn: "Создать турнир",
  createRegularTournament: "Создать турнир",
  createGiveawayTournament: "Создать турнир-раздачу",
  createQuickSolo: "Создать быстрый соло",
  creating: "Создание...",
  minimize: "Свернуть",
  expandChat: "Развернуть чат",
  minimizeChat: "Свернуть чат",
  closeChat: "Закрыть чат",
  prizePoolForWinners: "Призовой фонд для победителей",
  howItWorks: "Как это работает",
  howItWorksQuickSolo: "Быстрый матч 1 на 1 на Shipment. Первый до {kills} убийств или лучший счет на {time} выигрывает!",
  howItWorksGiveaway: "Вы платите {cost} очков ({prize} приз + {commission} комиссия). Игроки участвуют бесплатно. Победитель(и) получают ровно {prizePool} очков.",
  howItWorksRegular: "Общие вступительные взносы: {totalEntry} очков. После {commissionRate}% комиссии, призовой фонд составит {prizePool} очков.",
  locked: "Заблокировано",

  // ========== QUICK SOLO SPECIFIC ==========
  quickSolo: "⚡ Быстрый соло (1 на 1)",
  quickSoloTournament: "Быстрый соло турнир",
  killLimit: "Лимит убийств",
  timeLimit: "Лимит времени",
  timeLimitSeconds: "Лимит времени (секунды)",
  weaponRestrictions: "Ограничения оружия (необязательно)",
  selectAllowedWeapons: "Выберите разрешенные типы оружия (оставьте пустым для всего оружия)",
  selectedWeapons: "Выбранные типы оружия",
  allWeaponsAllowed: "Все оружие разрешено - нет ограничений",
  weaponRestrictionsWarning: "⚠️ Использование запрещенного оружия приведет к мгновенной дисквалификации!",
  allowedWeaponsOnly: "Разрешено только это оружие:",
  quickSoloInfo: "Быстрый соло: Быстрые матчи 1 на 1 только на Shipment. Идеально для быстрых битв за очки!",

  // ========== WEAPON TYPES ==========
  boltActionSniper: "Снайперская винтовка с затвором",
  shotgun: "Дробовик",
  assault: "Штурмовая",
  smg: "ПП",

  // ========== TOURNAMENT STATUSES ==========
  lobby: "ЛОББИ",
  wait: "ОЖИДАНИЕ",
  activeStatus: "АКТИВНО",
  finish: "ФИНИШ",
  deploying: "РАЗВЕРТЫВАНИЕ",
  standbyStatus: "ОЖИДАНИЕ",
  completed: "ЗАВЕРШЕНО",
  cancelled: "ОТМЕНЕНО",
  autoCanceled: "АВТО-ОТМЕНЕНО",

  // ========== TOURNAMENT ACTIONS ==========
  join: "ПРИСОЕДИНИТЬСЯ",
  abort: "ОТМЕНИТЬ",
  copy: "КОПИРОВАТЬ",
  deploy: "РАЗВЕРНУТЬ",

  // ========== МОДАЛЬНОЕ ОКНО ПРИСОЕДИНЕНИЯ К КОМАНДЕ BR ==========
  selectTeamPreference: "Выбор Предпочтения Команды",
  selectTeam: "Выберите Свою Команду",
  preference: "Предпочтение",
  soloTournament: "Соло Турнир",
  soloTournamentDesc: "Этот турнир требует, чтобы все игроки играли в одиночку. Напарники не допускаются.",
  randomTournament: "Открытый Командный Турнир",
  randomTournamentDesc: "Любой игрок может присоединиться и объединиться с другими. Выберите предпочтение команды ниже.",
  squadTournament: "Турнир Отряда",
  squadTournamentDesc: "Создатель указал напарников. Вы можете сформировать свой отряд или присоединиться случайно.",
  teamTournament: "Командный Турнир",
  creatorSquadmates: "Напарники Создателя:",
  duoTeamInfo: "Выберите, как вы хотите играть в этом Дуо турнире",
  squadTeamInfo: "Выберите, как вы хотите играть в этом турнире Отряда",
  yourTeamPreference: "Ваше Предпочтение Команды",
  soloTeam: "👤 Соло - Без напарников",
  soloLockedReason: "Создатель турнира установил режим Соло - все игроки должны играть в одиночку.",
  randomTeam: "🎲 Случайно - Любой игрок может присоединиться",
  squadTeam: "👥 Отряд - Выбрать конкретных напарников",
  selectSquadmates: "Выбрать Напарников",
  randomPlayer: "🎲 Случайный Игрок",
  playerName: "Имя Игрока",
  specific: "Конкретный Игрок",
  squadHelpText: "Переключение между конкретным именем игрока, случайным игроком или пустым местом",
  soloInfo: "Вы будете играть в одиночку. Никто не может присоединиться к вашей команде.",
  randomInfo: "Любой доступный игрок может присоединиться к вашей команде.",
  selectTeamToJoin: "Выберите команду для присоединения. Команды, отмеченные как недоступные, имеют ограничения.",
  randomPreference: "Предпочтение Случайного Напарника",
  squadPreference: "Предпочтение Отряда",
  noAvailableTeams: "Нет доступных команд. Все команды заполнены или имеют ограничения.",
  soloPlayerTeam: "Соло Игрок",
  squadOnly: "Только Отряд",
  available: "Доступно",
  spot: "место",
  spots: "мест",
  back: "Назад",

  // ========== ВЫБОР КОМАНДЫ MP ==========
  captainSettings: "Настройки Капитана Команды",
  captainSettingsInfo: "Как капитан команды, выберите, кто может присоединиться",
  teamJoinMode: "Режим Присоединения к Команде",
  randomTeammates: "Случайный - Любой может присоединиться",
  specificTeammates: "Конкретный - Выберите тиммейтов",
  selectTeammates: "Выберите Тиммейтов (по игровому имени)",
  slot: "Слот",
  clickToEmpty: "Нажмите, чтобы оставить пустым",
  clickForRandom: "Нажмите для случайного",
  setRandom: "Установить случайный",
  enterInGameName: "Введите игровое имя",
  anyPlayerCanJoin: "Любой игрок может занять этот слот",
  teammatesNote: "Оставьте слоты пустыми, чтобы другие не могли присоединиться",
  randomTeamInfo: "Любой игрок сможет присоединиться к вашей команде",
  youWillBeCaptain: "Вы будете капитаном команды",
  youAreInvited: "Вы приглашены в эту команду",
  joiningViaRandomSlot: "Присоединение через случайный слот",
  teamNotAccepting: "Эта команда не принимает игроков",
  notOnInviteList: "Вы не в списке приглашенных этой команды",
  invitedPlayers: "Приглашенные игроки:",
  createTeam: "Создать Команду",
  mpTeamSelectInfo: "Выберите, к какой команде присоединиться для этого матча",
  teamRestriction: "Ограничение Команды",
  teamSelectionHeading: "Выбор Команды",
  randomTeam: "Случайная Команда",
  specificTeam: "Конкретная Команда",

  // ========== TOURNAMENT DETAILS ==========
  giveaway: "РАЗДАЧА",
  highStakes: "ВЫСОКИЕ СТАВКИ",
  veryHighStakes: "ОЧЕНЬ ВЫСОКИЕ СТАВКИ",
  legendaryStakes: "ЛЕГЕНДАРНЫЕ СТАВКИ",
  passwordProtected: "🔒ПАРОЛЬ",
  roomId: "🎮 КОМНАТА",
  matchLive: "МАТЧ ИДЕТ",
  tournamentId: "ID турнира",
  copyTournamentId: "Копировать ID турнира",

  // ========== TOURNAMENT OPERATIONS ==========
  tournamentOps: "ОПЕРАЦИИ ТУРНИРА",
  intelUpdated: "Данные обновлены!",
  noActiveLobies: "НЕТ АКТИВНЫХ ЛОББИ",
  deployFirstTournament: "Разверните первый турнир!",
  noPendingDeployments: "НЕТ ОЖИДАЮЩИХ РАЗВЕРТЫВАНИЙ",
  fullLobbiesAppear: "Полные лобби появятся здесь (авто-отмена через 30 мин)",
  noActiveOperations: "НЕТ АКТИВНЫХ ОПЕРАЦИЙ",
  deployedTournamentsAppear: "Развернутые турниры появятся здесь",
  noCompletedMissions: "НЕТ ЗАВЕРШЕННЫХ МИССИЙ",
  finishedCancelledAppear: "Завершенные и отмененные турниры появятся здесь",
  noData: "НЕТ ДАННЫХ",
  nothingToShow: "Нечего показывать",
  refresh: "ОБНОВИТЬ",

  // ========== CHAT SYSTEM ==========
  chat: "Чат",
  searchPlayers: "Поиск игроков...",
  noPlayersOnline: "Нет других игроков онлайн",
  noPlayersMatch: "Нет игроков, соответствующих поиску",
  sendMessage: "Отправить",
  messageUser: "Сообщение",
  typing: "печатает...",
  connected: "Подключено к серверу!",
  hasUnread: "есть непрочитанные",
  newMessage: "Новое сообщение",
  from: "от",
  in: "в",

  // ========== POINTS & PROFILE ==========
  estimatedValue: "Ожидаемая стоимость",
  buyPoints: "Купить очки",
  withdraw: "Вывести",
  minimumWithdrawal: "Минимальная сумма вывода 1000 очков ($9.50)",
  profileManagement: "Управление профилем",
  editProfile: "Редактировать профиль",
  changePassword: "Изменить пароль",
  updateProfile: "Обновить профиль",

  // ========== WITHDRAWAL ==========
  requestWithdrawal: "Запрос на вывод",
  pointsToWithdraw: "Очков для вывода",
  paypalEmail: "PayPal Email",
  youllReceive: "Вы получите",
  platformFee: "комиссия платформы",
  withdrawalInfo: "Информация о выводе",
  minimum: "Минимум",
  submitRequest: "Отправить запрос",
  withdrawalMinimum: "Минимум: 1000 очков ($9.50)",
  withdrawalFee: "Комиссия платформы: 5%",
  withdrawalProcessing: "Обработка: 24-96 часов",
  feePercent: "комиссия 5%",
  info: "Информация",
  submitting: "Отправка...",
  submitting: "Отправка...",
  leaveEmptyToUse: "Оставьте пустым, чтобы использовать email вашего аккаунта",
  withdrawalHistory: "История выводов",
  noWithdrawalRequests: "Пока нет запросов на вывод.",
  note: "Примечание",

  // ========== PROFILE MANAGEMENT ==========
  currentPassword: "Текущий пароль",
  newPassword: "Новый пароль",
  confirmNewPassword: "Подтвердите новый пароль",
  enterCurrentPassword: "Введите текущий пароль",
  enterNewPassword: "Введите новый пароль (мин. 6 символов)",
  confirmYourNewPassword: "Подтвердите новый пароль",
  passwordsMatch: "✓ Пароли совпадают",
  passwordsDoNotMatch: "✗ Пароли не совпадают",
  securityTips: "Советы по безопасности",
  useAtLeast8Characters: "Используйте минимум 8 символов",
  includeUppercaseLowercase: "Включите заглавные и строчные буквы",
  addNumbersSpecialChars: "Добавьте цифры и специальные символы",
  dontUsePersonalInfo: "Не используйте личную информацию",
  changing: "Изменение...",
  makesSureThisMatches: "⚠️ Убедитесь, что это соответствует вашему точному игровому имени в CoD Mobile!",
  passwordStrength: "Надежность пароля",
  weak: "Слабый",
  medium: "Средний",
  strong: "Сильный",
  useUppercaseLowercase: "Используйте заглавные и строчные буквы, цифры и символы для более надежного пароля",
  testCurrentPassword: "Проверить текущий пароль",

  // ========== MATCH HISTORY ==========
  yourMatchHistory: "Ваша история матчей",
  noCompletedMatches: "Пока нет завершенных матчей.",
  joinTournamentsHistory: "Присоединяйтесь к турнирам, чтобы создать историю матчей!",
  entryFeeLabel: "Вход",
  prizeLabel: "Приз",
  dateLabel: "Дата",
  match: "Матч",
  mode: "Режим",
  date: "Дата",
  pts: "очк",
  pointsLabel: "Очки",
  split: "Разделено",
  ways: "способов",
  youLabel: "Вы",
  loadingMatchHistory: "Загрузка истории матчей...",

  // ========== INBOX SYSTEM ==========
  supportInbox: "Входящие поддержки",
  newReport: "Новый отчет",
  submitNewSupportReport: "Отправить новый отчет в поддержку",
  subject: "Тема",
  description: "Описание",
  submitReport: "Отправить отчет",
  noCasesYet: "Пока нет обращений",
  createNewReport: "Создайте новый отчет, если вам нужна помощь с турнирами, платежами или проблемами аккаунта.",
  submitFirstReport: "Отправить первый отчет",
  open: "Открыто",
  closed: "Закрыто",
  beforeSubmitting: "Перед отправкой:",
  beAsDetailed: "• Будьте максимально подробны в описании",
  includeRelevantUsernames: "• Включите соответствующие имена пользователей или ID турниров",
  supportTeamWillReview: "• Наша команда поддержки рассмотрит и ответит в течение 24 часов",
  minimumCharactersRequired: "Минимум 5 символов",
  minimum10CharactersRequired: "Минимум 10 символов",
  submissionProcess: "Процесс отправки:",
  reportWillBeSubmitted: "Ваш отчет будет отправлен изначально как закрытый и рассмотрен нашей командой поддержки. После рассмотрения они могут открыть его для дальнейшего общения, если это необходимо.",
  typeYourMessage: "Введите сообщение...",
  sending: "Отправка...",
  send: "Отправить",
  pressEnterShift: "Нажмите Enter + Shift для новой строки",
  caseNumber: "Обращение",
  updated: "Обновлено",
  messages: "сообщений",
  clickToView: "Нажмите для просмотра переписки",
  thisCaseIsClosed: "Это обращение закрыто. Вы не можете отвечать на закрытые обращения.",
  activeMatchDetails: "Детали активного матча",
  matchSettings: "🏆 Настройки матча",
  teamMembers: "👥 Члены команды",
  type: "Тип",

  // ========== ADMIN INBOX PANEL TRANSLATIONS ==========
  supportInboxManagement: "Управление входящими поддержки",
  createCase: "Создать обращение",
  totalCases: "Всего обращений",
  openCases: "Открытых обращений",
  closedCases: "Закрытых обращений",
  allStatus: "Все статусы",
  allAssignments: "Все назначения",
  unassigned: "Не назначено",
  assignedToMe: "Назначено мне",
  loadingCases: "Загрузка обращений...",
  noCasesFound: "Обращения не найдены",
  adjustFiltersOrCreateCase: "Измените фильтры или создайте новое обращение для пользователя",

  // Missing core translations
  unknown: "Неизвестно",
  mins: "м",
  hrs: "ч",
  daysShort: "д",
  ago: "назад",
  warning: "Предупреждение",
  view: "Просмотр",
  viewCase: "Просмотр",
  created: "Создано",
  createNewCaseForUser: "Создать новое обращение для пользователя",
  selectUser: "Выбрать пользователя",
  searchUsersUsername: "Поиск пользователей по имени, email или игровому имени...",
  selected: "Выбрано:",
  initialMessage: "Начальное сообщение",
  caseSubject: "Тема обращения...",
  initialMessageToUser: "Начальное сообщение пользователю...",
  createCaseBtn: "Создать обращение",
  closeCase: "Закрыть обращение",
  openCase: "Открыть обращение",
  assignToMe: "Назначить мне",
  unassignCase: "Снять назначение",
  deleteCase: "Удалить обращение",
  assignedTo: "Назначено:",
  systemMessage: "Система",
  typeYourResponse: "Введите ваш ответ...",
  deleteCaseModal: "Удалить обращение",
  deleteCaseWarning: "Предупреждение:",
  deleteCaseText: "Это действие нельзя отменить. Обращение и все его сообщения будут навсегда удалены.",
  deleting: "Удаление...",
  youAreCurrentlyViewing: "📝 Вы сейчас просматриваете это обращение",
  youAreViewingCasesList: "📋 Вы просматриваете список обращений",
  afterDeletionReturn: "После удаления вы вернетесь к списку обращений",
  listWillRefresh: "Список обновится после удаления",
  caseLabel: "Обращение:",
  userLabel: "Пользователь:",
  messagesLabel: "Сообщений:",
  newReportFrom: "Новый отчет от {user}: {subject}",
  newMessageInCase: "Новое сообщение в обращении {caseNumber}",
  caseAssignedToYou: "Обращение {caseNumber} назначено вам",
  pleaseFillAllFields: "Пожалуйста, заполните все поля",
  caseCreatedSuccessfully: "Обращение успешно создано",
  failedToCreateCase: "Не удалось создать обращение",
  pleaseEnterMessage: "Пожалуйста, введите сообщение",
  failedToSendMessage: "Не удалось отправить сообщение",
  caseStatusSuccessfully: "Обращение успешно {status}",
  failedToUpdateCaseStatus: "Не удалось обновить статус обращения",
  caseAssignedSuccessfully: "Обращение успешно назначено",
  caseUnassignedSuccessfully: "Назначение обращения успешно снято",
  failedToAssignCase: "Не удалось назначить обращение",
  caseDeletedSuccessfully: "Обращение успешно удалено",
  failedToDeleteCase: "Не удалось удалить обращение",
  noCaseSelectedForDeletion: "Не выбрано обращение для удаления",
  noCaseSelected: "Обращение не выбрано",
  reasonForClosing: "Причина закрытия этого обращения:",
  reasonForOpening: "Причина открытия этого обращения:",
  closing: "закрытие",
  opening: "открытие",
  assignment: "Назначение",
  status: "Статус",
  filtersLabel: "Фильтры",
  user: "Пользователь",
  createdLabel: "Создано",
  updatedLabel: "Обновлено",
  emptyStateTitle: "Обращения не найдены",
  emptyStateText: "Измените фильтры или создайте новое обращение для пользователя",

  // ========== INBOX ERROR MESSAGES ==========
  failedToLoadInbox: "Не удалось загрузить входящие",
  failedToLoadCase: "Не удалось загрузить обращение",
  pleaseFillBothFields: "Пожалуйста, заполните тему и описание",
  subjectMinLength: "Тема должна содержать минимум 5 символов",
  descriptionMinLength: "Описание должно содержать минимум 10 символов",
  reportSubmittedSuccessfully: "Отчет успешно отправлен",
  failedToSubmitReport: "Не удалось отправить отчет",
  messageTooLong: "Сообщение слишком длинное (макс. 1000 символов)",
  briefDescriptionPlaceholder: "Краткое описание вашей проблемы...",
  detailedDescriptionPlaceholder: "Пожалуйста, предоставьте подробную информацию о вашей проблеме, включая соответствующие имена пользователей, ID турниров или шаги для воспроизведения проблемы...",
  hasBeenLabel: "было",
  reopened: "открыто заново",
  yourCase: "Ваше обращение",
  hasBeenDeleted: "было удалено",

  // ========== PAYMENT SYSTEM ==========
  buyTournamentPoints: "Купить очки для турниров",
  chooseYourPerfectPackage: "Выберите идеальный пакет и начните соревноваться!",
  selectYourPackage: "Выберите пакет",
  chooseTheAmountOfPoints: "Выберите количество очков, соответствующее вашим игровым потребностям",
  instantDelivery: "Мгновенная доставка",
  securePayment: "Безопасный платеж",
  noExpiration: "Без срока действия",
  securePaymentInfo: "Информация о безопасном платеже",
  processingPayment: "Обработка платежа...",
  yourPaymentProcessedSecurely: "Ваш платеж безопасно обрабатывается PayPal",
  pointsAddedInstantly: "Очки мгновенно добавляются на ваш аккаунт",
  allTransactionsEncrypted: "Все транзакции зашифрованы и безопасны",
  noHiddenFeesOrCharges: "Нет скрытых комиссий или сборов",
  pointsPerDollar: "очков за $",

  // ========== PAYMENT PACKAGE DESCRIPTIONS ==========
  perfectForTryingOut: "Идеально для пробы",
  bestValueForBeginners: "Лучшая цена для начинающих",
  seriousPlayersChoice: "Выбор серьезных игроков",
  tournamentReady: "Готов к турниру",
  competitiveEdge: "Конкурентное преимущество",
  proTournamentBundle: "Про-турнирный пакет",
  maximumValuePack: "Пакет максимальной ценности",

  // ========== PACKAGE BADGES ==========
  starter: "Стартовый",
  basic: "Базовый",
  mostPopular: "Самый популярный",
  greatValue: "Отличная цена",
  powerPack: "Мощный пакет",
  ultimate: "Ультимативный",
  megaPack: "Мега-пакет",

  // ========== PURCHASE INSTRUCTIONS ==========
  howToPurchase: "Как купить",
  selectPackage: "Выберите пакет",
  chooseYourPreferredPackage: "Выберите предпочитаемый пакет очков выше",
  clickPayPal: "Нажмите PayPal",
  proceedWithSecureCheckout: "Перейдите к безопасной оплате через PayPal",
  completePayment: "Завершите платеж",
  finishTransactionViaPayPal: "Завершите транзакцию через PayPal",
  pointsAddedImmediatelyToAccount: "Очки немедленно добавляются на ваш аккаунт",

  // ========== TOURNAMENT MODES ==========
  snipersOnly: "ТОЛЬКО СНАЙПЕРЫ",
  rifleOnly: "ТОЛЬКО ВИНТОВКИ",
  knifeOnly: "ТОЛЬКО БЛИЖНИЙ БОЙ",
  executionOnly: "ТОЛЬКО КАЗНИ",
  grenadesOnly: "ТОЛЬКО ВЗРЫВЧАТКА",
  snipers: "СНАЙПЕРЫ",
  rifles: "ВИНТОВКИ",
  melee: "БЛИЖНИЙ БОЙ",
  execution: "КАЗНЬ",
  explosives: "ВЗРЫВЧАТКА",
  custom: "Особый",
  ffa: "Все против всех",

  // ========== GAME MODES ==========
  teamDeathmatch: "⚔️ Командный бой",
  domination: "🏁 Господство",
  searchAndDestroy: "💣 Найти и уничтожить",
  hardpoint: "📍 Хардпоинт",
  killConfirmed: "🏷️ Подтверждение убийств",
  captureTheFlag: "🚩 Захват флага",
  frontline: "⚡ Линия фронта",
  freeForAllMode: "🎯 Каждый сам за себя",
  gunGame: "🔫 Оружейная гонка",
  sticksAndStones: "Палки и камни",
  oneShotOneKill: "🎯 Один выстрел - одно убийство",
  cranked: "⚡ Взведенный",
  rapidFire: "💨 Быстрый огонь",
  attackOfTheUndead: "🧟 Атака нежити",

  // ========== GENERAL LABELS ==========
  tournament: "Турнир",
  random: "Случайный",

  // ========== MAPS ==========
  randomMap: "🎲 Случайная карта",

  // ========== PASSWORD MODAL ==========
  passwordProtectedTournament: "🔒 ТУРНИР ЗАЩИЩЕН ПАРОЛЕМ 🔒",
  tournamentPasswordProtected: "Этот турнир защищен паролем. Для участия вам нужен правильный пароль.",
  enterPassword: "Введите пароль",

  // ========== BAN MODAL ==========
  accountBanned: "🚫 Аккаунт заблокирован 🚫",
  accountBannedDesc: "Ваш аккаунт заблокирован и не может войти в систему.",
  bannedBy: "Заблокирован",
  contactSupport: "Свяжитесь с поддержкой, если вы считаете это ошибкой.",
  understood: "Понятно",

  // ========== FORM VALIDATION ==========
  fieldRequired: "Это поле обязательно",
  invalidEmail: "Введите корректный адрес электронной почты",
  passwordTooShort: "Пароль должен содержать минимум 6 символов",
  usernameMinLength: "Имя пользователя должно содержать минимум 3 символа",
  usernameMaxLength: "Имя пользователя должно быть менее 20 символов",
  invalidCharacters: "Содержит недопустимые символы",
  fieldTooLong: "Это поле слишком длинное",
  fieldTooShort: "Это поле слишком короткое",
  numberRequired: "Введите корректное число",
  numberTooLow: "Число слишком маленькое",
  numberTooHigh: "Число слишком большое",

  // ========== GENERAL ERRORS & MESSAGES ==========
  error: "Ошибка",
  success: "Успех",
  info: "Информация",
  failed: "Не удалось",
  retry: "Повторить",
  confirm: "Подтвердить",

  // ========== GENERAL ACTIONS ==========
  save: "Сохранить",
  delete: "Удалить",
  update: "Обновить",
  submit: "Отправить",
  reject: "Отклонить",

  // ========== MISSING ADMIN TRANSLATIONS ==========
  banUser: "Заблокировать пользователя",
  unbanUser: "Разблокировать пользователя",
  removeApprover: "Удалить одобрителя",
  failedToApproveMatch: "Не удалось одобрить матч",
  failedToCompleteMatch: "Не удалось завершить матч",
  startsIn: "Начало через",

  // ========== TIME & DATES ==========
  now: "сейчас",
  today: "сегодня",
  yesterday: "вчера",
  timeUntilAutoCancel: "мин до авто-отмены",
  timeRemaining: "мин осталось",

  // ========== NOTIFICATIONS ==========
  tournamentCreated: "Турнир успешно создан!",
  joinedTournament: "Успешно присоединились к турниру!",
  leftTournament: "Успешно покинули турнир!",
  profileUpdated: "Профиль успешно обновлен!",
  passwordChanged: "Пароль успешно изменен!",
  connectionRestored: "Соединение с сервером восстановлено",
  reconnecting: "Переподключение к серверу...",
  tournamentApproved: "Турнир одобрен",
  tournamentCompleted: "Турнир завершен",
  tournamentCancelled: "Турнир отменен",
  tournamentAutoCancelled: "Турнир авто-отменен: {tournamentName}",
  createdGiveawayTournament: "создал турнир-РАЗДАЧУ в лобби!",
  createdNewMatch: "создал новый матч в лобби!",
  isNowOnline: "сейчас онлайн!",
  commissionDistributed: "Комиссия распределена!",
  commissionUpdated: "Настройки комиссии обновлены!",

  // ========== ADDITIONAL STRINGS ==========
  participants: "Участники",
  insufficientPointsDetailed: "Недостаточно очков! Вам нужно {needed} очков, но у вас только {current} очков.",
  giveawayExplanation: "В турнирах-раздачах вы платите {prize} очков (приз) + {commission} очков (комиссия) = {total} всего",
  disobeyingWeaponRules: "⚠️ Нарушение правил использования оружия приведет к мгновенной потере очков!",
  estimatedPrizePoolCalculation: "Ожидаемый призовой фонд",
  baseCommission: "🏛️ Базовая комиссия",
  highKillBonus: "⚡ Бонус за много убийств",
  totalCommission: "📊 Общая комиссия",
  extraCommissionFromHighKills: "Дополнительная комиссия {rate}% от большого количества убийств идет одобрителю.",
  failedToLoadTournaments: "Не удалось загрузить турниры",
  system: "Система",

  // ========== TOURNAMENT CARD SPECIFIC ==========
  participantsCount: "{current}/{max}",
  prizeFormat: "🏆{amount}",
  entryFormat: "💰{amount}",
  killsFormat: "💀{amount}K",
  modeFormat: "⚔️{mode}",
  mapFormat: "📍{map}",
  teamFormat: "👥{count}",
  timeFormat: "⏰{time}",
  dateFormat: "📅{date}",

  // ========== WAIT TIME WARNINGS ==========
  warningAutoCancel: "⚠️ {time}мин до авто-отмены",
  warningTimeRemaining: "⏰ {time}мин осталось",

  // ========== ACTIVE MATCH ==========
  gameSettings: "Настройки игры",
  prizePool: "Призовой фонд",

  // ========== FINISHED TOURNAMENTS ==========
  autoCancel: "АВТО-ОТМЕНЕНО",
  canceled: "ОТМЕНЕНО",
  cancelledBy: "Отменено",
  more: "еще",
  approvedBy: "Одобрено",

  // ========== TOURNAMENT FIXES ==========
  failedToCreateTournament: "Не удалось создать турнир",
  matchType: "Тип матча",

  // ========== VOTE EARLY START ==========
  voteEarlyStart: "Голосование за ранний старт",
  voteToStart: "Голосовать за старт",
  votedToStart: "Проголосовал за старт",
  votesNeeded: "голосов нужно",
  allPlayersVoted: "Все игроки проголосовали!",
  waitingForVotes: "Ожидание голосов...",
  youVoted: "Вы проголосовали",
  earlyStartInfo: "Турнир может начаться раньше, если все проголосуют",

  // ========== BR TEAM AUTO-ASSIGNMENT ==========
  autoAssignTeams: "Авто-назначение команд",
  teamAssignment: "Назначение команды",
  assignedToTeam: "Назначен в команду",
  joiningTeam: "Присоединение к команде...",
  teamAutoAssigned: "Вы автоматически назначены в команду {team}",

  // ========== GIVEAWAY CREATOR CONTROLS ==========
  creatorControls: "Управление создателя",
  startNow: "Начать сейчас",
  cancelGiveaway: "Отменить раздачу",
  giveawayStarted: "Раздача началась!",
  confirmStartGiveaway: "Начать раздачу сейчас?",
  confirmCancelGiveaway: "Отменить эту раздачу?",

  // ========== ALCATRAZ MAP ==========
  alcatraz: "Алькатрас",
  alcatrazDesc: "Быстрая игра на маленькой карте BR",

  // ========== МНОГОЭТАПНЫЙ ТУРНИР ==========
  multistepTournaments: "Многоэтапные турниры",
  multistepTournament: "Многоэтапный турнир",
  createBracketTournament: "Создать многоэтапный турнир",
  createBracket: "Создать",
  noBracketTournaments: "Пока нет многоэтапных турниров",
  bracketTournamentCreated: "Многоэтапный турнир создан!",
  numberOfTeams: "Количество команд",
  costSummary: "Сводка расходов",
  prizePerWinner: "Приз победителю",
  confirmCreate: "Подтвердить создание турнира",
  viewBracket: "Сетка",
  tournamentBracket: "Турнирная сетка",
  joinedTeam: "Успешно присоединились к команде!",
  tournamentStarted: "Турнир начался!",
  confirmWinner: "Установить эту команду победителем?",
  yourTeam: "Ваша команда",
  registration: "РЕГИСТРАЦИЯ",
  final: "Финал",
  semiFinals: "Полуфиналы",
  quarterFinals: "Четвертьфиналы",
  round: "Раунд",
  matches: "матчи",
  tbd: "TBD",
  clickToSelectWinner: "Нажмите на команду чтобы выбрать победителя",
  perWinner: "За победителя",
  tournamentWinners: "Победители турнира",
  full: "ПОЛНЫЙ",
  showTeams: "Показать команды",
  hideTeams: "Скрыть команды",
  startTournament: "Старт",
  viewAllTeams: "Все команды и матчи",
  allTeamsMatchups: "Все команды и матчи",
  teams: "Команды",
  activeBracketMatches: "Активные матчи сетки",
  configureMatch: "Настроить матч",
  configureMatchups: "Настроить матчи",
  startMatch: "Начать матч",
  applications: "Заявки",
  pendingTeams: "Ожидающие команды",
  approvedTeams: "Одобренные команды",
  pendingApplications: "Ожидающие заявки",
  noApplications: "Нет ожидающих заявок",
  noApprovedTeamsYet: "Пока нет одобренных команд",
  pendingTeamsApproval: "Команды ожидают одобрения",
  pendingTeamsInfo: "Эти команды ожидают одобрения",
  approveTeam: "Одобрить",
  rejectTeam: "Отклонить",
  teamApproved: "Команда одобрена!",
  teamRejected: "Команда отклонена и удалена",
  applicationApproved: "Заявка одобрена!",
  applicationRejected: "Заявка отклонена",
  errorApprovingTeam: "Ошибка одобрения команды",
  errorRejectingTeam: "Ошибка отклонения команды",
  errorApproving: "Ошибка одобрения",
  errorRejecting: "Ошибка отклонения",
  applyToTournament: "Подать заявку на турнир",
  applyToJoin: "Подать заявку",
  applyToTeam: "Подать заявку",
  applying: "Подача заявки...",
  applied: "Заявка подана",
  teamApplied: "Заявка команды подана! Ожидание одобрения админа.",
  applicationSubmitted: "Заявка подана! Ожидание одобрения админа.",
  applicationPending: "Ваша заявка на",
  isPending: "ожидает одобрения",
  awaitingApproval: "Ожидание одобрения",
  createNewTeam: "Создать новую команду",
  youAreCaptain: "Вы капитан команды!",
  captainInfo: "Как капитан, вы можете установить предпочтения для тех, кто может присоединиться к вашей команде.",
  teamPreferences: "Настройки команды",
  setPreferencesFirst: "Сначала выберите команду",
  captain: "Капитан",
  teamName: "Название команды",
  enterTeamName: "Введите название команды",
  teammates: "Товарищи по команде",
  teammate: "Товарищ по команде",
  teammatesHint: "Введите имена пользователей ваших 4 товарищей по команде",
  teammatesUpdated: "Имена товарищей по команде обновлены!",
  editTeammates: "Редактировать имена товарищей",
  editTeammateNames: "Редактировать имена товарищей",
  editNames: "Редактировать имена",
  editHint: "Обновите имена пользователей ваших товарищей по команде",
  saveChanges: "Сохранить изменения",
  saving: "Сохранение...",
  need4Teammates: "Вы должны указать всех 4 товарищей по команде",
  needMoreTeammates: "Нужно больше имен товарищей по команде",
  duplicateNames: "Имена товарищей по команде должны быть уникальными",
  dontIncludeYourself: "Не включайте себя в список товарищей по команде",
  errorCreatingTeam: "Ошибка создания команды",
  yourAllowedSquadmates: "Ваши разрешённые сокомандники",
  noSquadmatesSet: "Сокомандники не указаны - любой может присоединиться к вашей команде",
  edit: "Редактировать",
  save: "Сохранить",
  saving: "Сохранение...",
  errorUpdating: "Ошибка обновления товарищей по команде",
  joinThisTeam: "Присоединиться к команде",
  joinYourTeam: "Присоединиться к своей команде",
  leaveTeam: "Покинуть команду",
  confirmLeave: "Вы уверены что хотите выйти?",
  errorJoining: "Ошибка присоединения к команде",
  errorLeaving: "Ошибка выхода",
  kickPlayer: "Удалить игрока",
  kickTeam: "Исключить/Дисквалифицировать команду",
  playerKicked: "Игрок удален из команды",
  teamKicked: "Команда исключена",
  confirmKick: "Удалить этого игрока из вашей команды?",
  enterKickReason: "Введите причину исключения/дисквалификации команды:",
  errorKicking: "Ошибка удаления игрока",
  errorKickingTeam: "Ошибка исключения команды",
  invited: "Приглашенные",
  inviteOnly: "Только по приглашению",
  yourNameInvited: "Ваше имя должно быть в списке приглашенных для присоединения",
  waiting: "ожидание",
  waitingToJoin: "ожидает присоединения",
  captain: "Капитан",
  totalSlots: "Всего мест",
  alreadyJoined: "Уже присоединились",
  allTeamsTaken: "Все команды заняты",
  teamsReady: "команд готово",
  teamsWaitingForYou: "Команды ждут вас",
  applyHint: "Подайте заявку в существующую команду или создайте свою",
  applyHintAdmin: "Создайте команды и настройте матчи",
  createHintFull: "Все места в командах заполнены",
  enterRoomId: "Введите ID комнаты",
  customMap: "Пользовательская карта",
  enterCustomMapName: "Введите название пользовательской карты",
  matchStarted: "Матч начался!",
  errorStartingMatch: "Ошибка запуска матча",
  confirmStart: "Начать турнир? Команды будут заблокированы.",
  errorStarting: "Ошибка запуска турнира",
  selectWinner: "Выбрать победителя",
  errorSettingWinner: "Ошибка установки победителя",
  cancelReason: "Причина отмены:",
  errorCancelling: "Ошибка отмены",
  firstRoundMatchups: "Матчи первого раунда",
  matchupHint: "Настройте какие команды играют друг против друга",
  saveMatchups: "Сохранить матчи",
  selectBothTeams: "Пожалуйста выберите обе команды для всех матчей",
  duplicateTeam: "Каждая команда может использоваться только один раз",
  matchupsConfigured: "Матчи успешно настроены!",
  errorConfiguringMatchups: "Ошибка настройки матчей",
  adjustSizeTo: "Настроить на",
  confirmAdjustSize: "Настроить размер сетки? Это перегенерирует структуру.",
  bracketAdjusted: "Сетка настроена",
  errorAdjustingSize: "Ошибка настройки размера сетки",
  allTeamsApproved: "Все команды одобрены",
  approveAllTeams: "Одобрить все команды",
  confirmApproveAll: "Одобрить все ожидающие команды?",
  reroll: "Перебросить",
  rerollMatchup: "Случайный обмен",
  other: "Другое",
  otherMatchup: "Выбрать команду для обмена",
  selectTeamToSwap: "Выберите команду для обмена:",
  teamSwapped: "Команда обменяна!",
  errorSwappingTeam: "Ошибка обмена команды",
  or: "или",
  fillAllFields: "Пожалуйста заполните все поля",
  required: "Обязательно",
  prizeSummary: "Сводка призов",
  freeForAdmins: "Бесплатно для админов",
  gameModePerMatch: "Режим игры и карта настраиваются для каждого матча отдельно",
  each: "каждый",
  starting: "Запуск...",
  pendingApproval: "ожидание",

  // ========== VOTE TO START EARLY ==========
  voteEarlyStart: "Голосование за ранний старт",
  voteToStart: "Голосовать за ранний старт",
  voteToStartEarly: "Голосовать за ранний старт турнира",
  voteRecorded: "Голос записан! ({current}/{total})",
  voteRemoved: "Голос удален",
  voteRequestSent: "Запрос на голосование отправлен всем участникам!",
  voteInProgress: "Голосование идет ({current}/{total})",
  vote: "ГОЛОС",
  earlyPrize: "Ранний старт",
  votesNeeded: "голосов нужно",
  votedPlayers: "Проголосовавшие игроки",
  voteRequestSentWaiting: "Запрос на голосование отправлен! Ожидание игроков...",
  voteNote: "Турнир начнется автоматически когда все реальные игроки проголосуют.",
  voteNoteGiveaway: "Для раздач создатель должен вручную запустить матч после получения всех голосов.",

  // ========== CREATE TOURNAMENT TEAM PREFERENCE ==========
  teamPreference: "Предпочтение команды",
  randomAnyPlayerCanJoin: "Случайный - Любой игрок может присоединиться к вашей команде",
  specificChooseTeammates: "Конкретный - Выберите вашего(-их) тиммейта(-ов)",
  emptySlotOptional: "Пустой слот (необязательно)",
  enterPlayerInGameName: "Введите игровое имя игрока",

  // ========== BR EDIT TEAM ==========
  editTeam: "Редактировать команду",
  viewTeam: "Просмотр команды",
  viewPlayers: "Просмотр игроков",
  viewTeamPositions: "Позиции команд",
  editAllowedTeammates: "Редактировать разрешённых тиммейтов",
  teammatesHint: "Введите имена игроков, которым разрешено присоединиться к вашей команде. Оставьте пустым или установите случайный режим, чтобы разрешить всем.",
  mpTeammatesHint: "Введите имена игроков для разрешения конкретных игроков. Используйте 🎲 для случайных игроков. Пустые слоты заблокированы.",
  specificPreference: "Специфический режим - Только указанные игроки могут присоединиться",
  captain: "Капитан",
  specific: "СПЕЦИФИЧНЫЙ",
  lockedSlot: "Заблокированный слот",
  lockedSlotInfo: "🔒 Заблокировано - никто не может присоединиться",
  openSlot: "Открытый слот",
  waitingFor: "Ожидание",
  unlockSlot: "Разблокировать слот (разрешить случайного)",
  lockSlot: "Заблокировать слот",

  // ========== KICK PLAYER MODAL ==========
  kickPlayerTitle: "Удалить игрока",
  kickPlayerConfirm: "Вы уверены что хотите удалить этого игрока?",
  kickFillerConfirm: "Удалить этого филлера из турнира?",
  removeFromTournament: "Удалить из турнира",
  kickReason: "Причина (необязательно)",

  // ========== MP TEAM SELECTION ==========
  teamSelection: "Выбор команды",
  selectTeam: "Выберите свою команду",
  mpTeamSelectInfo: "Выберите к какой команде присоединиться в этом матче",
  youWillBeCaptain: "Вы будете капитаном команды",
  youAreInvited: "Вы приглашены в эту команду",
  joiningViaRandomSlot: "Присоединение через случайный слот",
  teamNotAccepting: "Эта команда не принимает игроков",
  squadOnly: "Только отряд",
  spotsAvailable: "мест доступно",
  captainSettings: "Настройки капитана команды",
  captainSettingsInfo: "Как капитан команды, выберите кто может присоединиться",
  teamJoinMode: "Режим присоединения к команде",
  randomTeammate: "🎲 Случайный - Любой игрок может присоединиться к вашей команде",
  specificTeammate: "👥 Конкретный - Выберите вашего(-их) тиммейта(-ов)",
  slot: "Слот",
  clickToEmpty: "Нажмите чтобы оставить пустым",
  clickForRandom: "Нажмите для случайного",
  random: "Случайный",
  setRandom: "Установить случайного",
  anyPlayerCanJoin: "Любой игрок может присоединиться к этому слоту",
  teammatesNote: "Оставьте слоты пустыми чтобы запретить другим присоединяться к вашей команде",
  joining: "Присоединение...",
  createTeam: "Создать команду",
  joinTeam: "Присоединиться к команде",
  editTeamPreferences: "Редактировать настройки команды",
  viewAllTeamPositions: "Показать все позиции команд",
  emptySlot: "Пустой слот",
  enterPlayerInGameName: "Введите игровое имя игрока",
  enterNameOrSetRandom: "Введите имя или выберите случайного",
  enterExactInGameName: "Введите точное игровое имя вашего тиммейта, или выберите случайного",
  editAllowedSquadmates: "Редактировать разрешенных тиммейтов",
  squadPreference: "Режим отряда - Только определенные тиммейты",
  randomPreference: "Случайный режим - Любой может присоединиться",
  squadmatesHint: "Введите имена игроков, которым разрешено присоединиться к вашей команде. Оставьте пустым или выберите случайного, чтобы разрешить всем.",
  slot: "Слот",
  anyoneCanJoin: "Любой может присоединиться к этому слоту",
  emptySlotInfo: "Пусто - никто не может использовать этот слот",
  specificPlayer: "Только этот игрок может присоединиться",
  clearSlot: "Очистить слот",
  randomPlayer: "Случайный игрок",
  enterPlayerName: "Введите имя игрока...",
  playerName: "Имя игрока",
  saveChanges: "Сохранить изменения",
  saving: "Сохранение...",

  // ========== VOTE EARLY START MODAL ==========
  prizeReductionWarning: "Предупреждение об уменьшении приза",
  lobbyNotFull: "Лобби не заполнено ({current}/{max} игроков)",
  current: "Текущий",

  // ========== KICK PLAYER MODAL EXTRAS ==========
  kick: "Кикнуть",
  realPlayer: "Реальный игрок",
  fillerPlayer: "Филлер",
  fillerBot: "Бот-филлер",
  playerWillReceiveRefund: "Игрок получит возврат {amount} очков",
  thisActionIsPermanent: "Это действие необратимо",
  playerWillBeRemoved: "Этот игрок будет удален из турнира и не сможет присоединиться снова.",
  tournamentInformation: "Информация о турнире",
  currentPlayers: "Текущие: {current}/{max} игроков",
  kickParticipant: "Кикнуть {type}",
  player: "Игрок",
  filler: "Филлер",
  yourFiller: "Ваш филлер",
  youAddedThis: "Вы добавили этого филлера",
  othersFiller: "Филлер другого игрока",
  addedBySomeoneElse: "Добавлен другим игроком",
  refundInformation: "Информация о возврате",
  playerRefund: "Игрок получит возврат {amount} очков",
  fillerRefund: "Владелец филлера получит возврат {amount} очков",
  fillerRefundNote: "Возврат получит тот, кто добавил филлера",
  permanentAction: "Это действие необратимо",
  playerKickWarning: "Этот игрок будет удален из турнира и не сможет присоединиться снова.",
  fillerKickWarning: "Этот филлер будет удален из турнира и не может быть добавлен снова.",
  tournamentInfo: "Информация о турнире",
  currentParticipants: "Текущие: {current}/{max} игроков",
  currentFillers: "Филлеры: {count}",
  kicking: "Удаление...",
  confirmKick: "Кикнуть {type}",
  // Subscription translations
  
  
  // ========== MP MULTISTEP & ADDITIONAL ==========
  mpMultistep: "MP Многоэтапный",
  mpMultistepDesc: "Командный мультиплеерный турнир с сеткой. 5 игроков в команде.",
  teamsCount: "4, 8 или 16 команд",
  bracketElimination: "Формат на выбывание",
  gameModePerMatch: "Режим игры устанавливается для каждого матча",
  soloSquadModes: "Режимы Соло, Дуо или Отряд",
  roundsRange: "2-5 раундов",
  cumulativePoints: "Накопительные очки за убийства + место",
  pts: "очк",
// ========== BR MULTISTEP TOURNAMENT ==========
  brMultistep: "BR Многоэтапный",
  brMultistepDesc: "Турнир Battle Royale с несколькими раундами",
  br_multistep: "BR Многоэтапный",
  createBRMultistep: "Создать BR Многоэтапный турнир",
  brMultistepCreated: "BR Многоэтапный турнир успешно создан",
  solo: "Соло",
  soloDesc: "Индивидуальные игроки соревнуются",
  duo: "Дуо",
  duoDesc: "Команды из 2 игроков",
  squad: "Отряд",
  squadDesc: "Команды из 4 игроков",
  controlMode: "Режим управления",
  control: "Управление",
  manual: "Ручной",
  manualDesc: "Админ управляет комнатами вручную",
  bot: "Бот",
  botDesc: "Бот создает и управляет комнатами автоматически",
  botIdle: "Бот ожидает",
  botCreatingRoom: "Создание комнаты...",
  botRoomReady: "Комната готова",
  botWaitingPlayers: "Ожидание игроков",
  botMatchActive: "Матч идет",
  botExtractingResults: "Извлечение результатов",
  botRoundComplete: "Раунд завершен",
  botError: "Ошибка бота",
  botReconnected: "Бот переподключился",
  numberOfRounds: "Количество раундов",
  rounds: "Раунды",
  scheduledStart: "Запланированный старт",
  scheduledStartHint: "Когда турнир должен начаться",
  pointsConfiguration: "Настройка очков",
  pointsPerKill: "Очков за убийство",
  perKill: "за убийство",
  placementPoints: "Очки за место",
  placementHint: "Очки за финальное место",
  addPlacement: "Добавить место",
  place: "Место",
  pointsDistribution: "Распределение очков",
  teams: "Команды",
  allTeams: "Все команды",
  noTeamsYet: "Команд пока нет",
  createNewTeam: "Создать новую команду",
  teamName: "Название команды",
  enterTeamName: "Введите название команды",
  teammates: "Тиммейты",
  teammate: "Тиммейт",
  enterTeammateNames: "Введите имена тиммейтов",
  enterAllTeammates: "Введите все имена тиммейтов",
  teamSize: "Размер команды",
  teamWillHave: "В команде будет",
  youPlus: "Вы +",
  editTeam: "Редактировать команду",
  editTeammatesHint: "Редактировать тиммейтов",
  editTeamNote: "Можно редактировать команду до начала турнира",
  teamUpdated: "Команда успешно обновлена",
  viewTeams: "Просмотр команд",
  yourTeam: "Ваша команда",
  leader: "Лидер",
  joinThisTeam: "Присоединиться к этой команде",
  joinMyTeam: "Присоединиться к моей команде",
  joinMyTeamSelect: "Выберите команду для присоединения",
  joinWithTeam: "Присоединиться с командой",
  selectYourTeam: "Выберите вашу команду",
  joinedTeam: "Успешно присоединились к команде",
  leaveTeam: "Покинуть команду",
  duplicateTeammate: "Дублирующееся имя тиммейта",
  multipleTeamsInvited: "Можно пригласить несколько команд",
  pendingSlots: "Свободные места",
  manageRounds: "Управление раундами",
  matchSettings: "Настройки матча",
  editSettings: "Редактировать настройки",
  saveSettings: "Сохранить настройки",
  saveChanges: "Сохранить изменения",
  settingsSaved: "Настройки успешно сохранены",
  confirmCreate: "Создать турнир?",
  confirmStart: "Начать турнир?",
  confirmCancel: "Отменить турнир?",
  confirmSwitchToManual: "Переключить на ручное управление?",
  switchedToManual: "Переключено на ручное управление",
  roundStarting: "Раунд начинается",
  lobby: "Лобби",
  inProgress: "В процессе",
  completed: "Завершен",
  cancelled: "Отменен",
  startsAt: "Начало в",
  joining: "Присоединение...",
  creating: "Создание...",
  saving: "Сохранение...",
  joinTournament: "Присоединиться к турниру",
  joinedTournament: "Присоединились к турниру",
  leftTournament: "Покинули турнир",
  tournamentStarted: "Турнир начался",
  tournamentCancelled: "Турнир отменен",
  tournamentSummary: "Сводка турнира",
  errorCreating: "Ошибка создания турнира",
  failedToJoin: "Не удалось присоединиться к турниру",
  failedToJoinTeam: "Не удалось присоединиться к команде",
  failedToLeave: "Не удалось покинуть",
  failedToStart: "Не удалось начать",
  failedToStartRound: "Не удалось начать раунд",
  failedToCancel: "Не удалось отменить",
  failedToSaveSettings: "Не удалось сохранить настройки",
  failedToUpdateTeam: "Не удалось обновить команду",
  switchFailed: "Не удалось переключить",
  commandFailed: "Команда не выполнена",
  reconnectFailed: "Не удалось переподключиться",
  commandSent: "Команда отправлена",
  maxPlayers: "Макс. игроков",
  leaveEmptyForPublic: "Оставьте пустым для публичного",
  optional: "Необязательно",
  required: "Обязательно",
  freeForAdmins: "Бесплатно для админов",
  minPlayersRequired: "Требуется минимум игроков",
  playersNotDivisible: "Количество игроков не делится на размер команды",
  selectTournamentType: "Выберите тип турнира",

  weeklyPointDeals: "Еженедельные предложения",
  subscriptionDescription: "50% очков сразу + 50% ежедневно в течение 7 дней",
  activePlan: "Активно",
  dayProgress: "День",
  pointsReceived: "очков получено",
  alreadyActive: "Уже активно",
  selectPlan: "Выбрать план",
  totalPoints: "ВСЕГО ОЧКОВ",
  instant: "сразу",
  perDay: "/день",
  days: "дней",
  ptsPerDollar: "очк за $1",
  perWeek: "/неделя",
  processingSubscription: "Обрабатываем вашу подписку...",
  tierBasic: "Базовый",
  tierStandard: "Стандарт",
  tierPlus: "Плюс",
  tierPremium: "Премиум",
  tierMax: "Макс",
};

export default russianTranslations;
